import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ResetFiltersService {

  // Use a counter that increments to trigger reset events
  private _resetTriggered = signal<number>(0);
  readonly resetTriggered = this._resetTriggered.asReadonly();

  // Computed signal for derived state
  readonly hasResetTriggered = computed(() => this._resetTriggered() > 0);

  constructor() { }

  // Method to trigger reset - increments counter to notify all listeners
  triggerReset() {
    this._resetTriggered.set(this._resetTriggered() + 1);
  }

  // Method to check if reset was triggered
  isResetTriggered(): boolean {
    return this.hasResetTriggered();
  }

  // Method to get current reset count (useful for effects)
  getResetCount(): number {
    return this._resetTriggered();
  }
}
